import { useAuth0 } from '@auth0/auth0-react';
import { FlexLayout } from '@deity/falcon-ui';
import { ComponentFactory } from '@deity-io/di-data-flows-editor';
import { DefinitionFactory, MappingFactory } from '@deity-io/di-data-structure-editor';
import { Box, Button, H1, H3 } from '@deity-io/portal-ui';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { CACHE_FIRST } from 'contracts/constants';
import _ from 'lodash';
import type { FC } from 'react';
import { useEffect } from 'react';
import { useGetConfigSchemasQuery } from 'services/graphql/generated/hooks';
import type { IContainerChildrenProps } from 'utils';

export const WithConfigLoader: FC<IContainerChildrenProps> = ({ children }) => {
  const { isAuthenticated, error: auth0Error, isLoading, loginWithRedirect } = useAuth0();

  const {
    loading: loadingConfigSchemas,
    data: configSchemas,
    error
  } = useGetConfigSchemasQuery({
    skip: !isAuthenticated,
    ...CACHE_FIRST
  });

  // useEffect(() => {
  //   if (!isAuthenticated) {
  //     loginWithRedirect();
  //   }
  // });

  useEffect(() => {
    if (configSchemas?.getConfigSchemas) {
      DefinitionFactory.load(configSchemas?.getConfigSchemas.modelSchema);
      MappingFactory.load(configSchemas?.getConfigSchemas.mappingSchema);
      ComponentFactory.load(_.cloneDeep(configSchemas?.getConfigSchemas.flowComponentsSchema));
    }
  }, [configSchemas]);

  // Control is used before the protected routes. Do not block child rendering if not yest authenticated
  const showBackdrop = isAuthenticated && (loadingConfigSchemas || !_.isUndefined(error));
  if (error) {
    // eslint-disable-next-line no-console
    console.warn('Error in WithConfigLoader', error);
  }

  return showBackdrop ? (
    <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={showBackdrop}>
      {loadingConfigSchemas && (
        <FlexLayout alignItems="center" flexDirection="column">
          <CircularProgress color="inherit" sx={{ marginBottom: '24px' }} />
          <H3 fontWeight="bold">Loading configuration schemas</H3>
        </FlexLayout>
      )}
      {error && (
        <FlexLayout alignItems="center" flexDirection="column">
          <Box marginBottom="24px">
            <H1>:-(</H1>
            <H3>Sorry, something went wrong. Please refresh the page. </H3>
          </Box>
          <Button variant="contained" onClick={() => location.reload()}>
            Refresh the page
          </Button>
        </FlexLayout>
      )}
    </Backdrop>
  ) : (
    <>{children}</>
  );
};
